import { render } from "./DeckCard.vue?vue&type=template&id=457f2464&scoped=true"
import script from "./DeckCard.vue?vue&type=script&lang=js"
export * from "./DeckCard.vue?vue&type=script&lang=js"

import "./DeckCard.vue?vue&type=style&index=0&id=457f2464&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457f2464"]])

export default __exports__